import React from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import MPP_admissionEle from "./MPP_admissionEle";

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <MPP_admissionEle />
        </>
    );
}

export default Main;
